import item from './item';
import list from './list';
export default {
  namespaced: true,
  modules: {
    list,
    item
  },
  mutations: {},
  actions: {}
};
/*
export default {
  namespaced: true,
  state: {
    data: [],
    settings: []
  },
  getters: {
    keys: state => Object.keys(state.data[0]).map(i => ({ value: i, text: i }))
  },
  mutations: {
    [SET_LIST](state, v) {
      state.data = v;
    },
    setSettings(state, v) {
      state.settings = v;
    }
  },
  actions: {
    [LOAD]({ commit }) {
      const list = [];
      for (let i = 0; i < 100; i++) {
        list.push({
          id: i,
          name: `Name #${nanoid()}`,
          column: nanoid(),
          column2: nanoid(),
          column4: nanoid(),
          column5: nanoid(),
          column6: nanoid()
        });
      }
      commit(SET_LIST, list);
      commit(
        "setSettings",
        Object.keys(list[0]).map(i => {
          let selected = true;
          if (i === "avatar") {
            selected = false;
          }
          return {
            id: i,
            value: i,
            text: i,
            selected
          };
        })
      );
    }
  }
};
*/
